import { render, staticRenderFns } from "./MshipsFormHeader.vue?vue&type=template&id=10641907"
import script from "./MshipsFormHeader.vue?vue&type=script&lang=js"
export * from "./MshipsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports